// extracted by mini-css-extract-plugin
module.exports = {"btnCol":"invoicesimplifiedheader_btnCol__2dm6f"};